import script from "./CommonHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonHeader.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__